export enum TipoStatusAgendamentoContato {
  AGENDADO = "AGENDADO",
  PROXIMO_7_DIAS = "PROXIMO_7_DIAS",
  AGENDADO_HOJE = "AGENDADO_HOJE",
  ATRASADO = "ATRASADO",
  CONCLUIDO = "CONCLUIDO",
}

export const getStatusAgendamentoFormatado = (
  situacaoAgendamento: TipoStatusAgendamentoContato
) => {
  switch (situacaoAgendamento) {
    case TipoStatusAgendamentoContato.AGENDADO:
      return "Agendado";
    case TipoStatusAgendamentoContato.AGENDADO_HOJE:
      return "Agendado para hoje";
    case TipoStatusAgendamentoContato.ATRASADO:
      return "Atrasado";
    case TipoStatusAgendamentoContato.PROXIMO_7_DIAS:
      return "Próximos 7 dias";
    case TipoStatusAgendamentoContato.CONCLUIDO:
      return "Concluído";
  }
};
